export default function groupBy(array, keySelector) {
    var _a;
    const result = new Map();
    for (const item of array) {
        const key = keySelector(item);
        const items = (_a = result.get(key)) !== null && _a !== void 0 ? _a : [];
        items.push(item);
        result.set(key, items);
    }
    return result;
}
